import Badge from "./Badge";

export {
    Badge as default,
};
